<template>
<div class="chapter">
<div class="inner_page">
<p class="tochead"><span>Contents</span></p>
<p class="toc1"><span><a href="#/xhtml/part01">Part I Sun Gift</a></span></p>
<p class="toc"><span><a href="#/xhtml/frantmatter03">Prologue</a></span></p>
<p class="toc"><span><a href="#/xhtml/chapter01">Chapter 1</a></span></p>
<p class="toc"><span><a href="#/xhtml/chapter02">Chapter 2</a></span></p>
<p class="toc"><span><a href="#/xhtml/chapter03">Chapter 3</a></span></p>
<p class="toc"><span><span href="#/xhtml/chapter04" title="Link target outside of Sample">Chapter 4</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter05" title="Link target outside of Sample">Chapter 5</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter06" title="Link target outside of Sample">Chapter 6</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter07" title="Link target outside of Sample">Chapter 7</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter08" title="Link target outside of Sample">Chapter 8</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter09" title="Link target outside of Sample">Chapter 9</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter10" title="Link target outside of Sample">Chapter 10</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter11" title="Link target outside of Sample">Chapter 11</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter12" title="Link target outside of Sample">Chapter 12</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter13" title="Link target outside of Sample">Chapter 13</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter14" title="Link target outside of Sample">Chapter 14</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter15" title="Link target outside of Sample">Chapter 15</span></span></p>
<p class="toc1"><span><span href="#/xhtml/part02" title="Link target outside of Sample">Part II</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter16" title="Link target outside of Sample">Chapter 16</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter17" title="Link target outside of Sample">Chapter 17</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter18" title="Link target outside of Sample">Chapter 18</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter19" title="Link target outside of Sample">Chapter 19</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter20" title="Link target outside of Sample">Chapter 20</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter21" title="Link target outside of Sample">Chapter 21</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter22" title="Link target outside of Sample">Chapter 22</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter23" title="Link target outside of Sample">Chapter 23</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter24" title="Link target outside of Sample">Chapter 24</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter25" title="Link target outside of Sample">Chapter 25</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter26" title="Link target outside of Sample">Chapter 26</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter27" title="Link target outside of Sample">Chapter 27</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter28" title="Link target outside of Sample">Chapter 28</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter29" title="Link target outside of Sample">Chapter 29</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter30" title="Link target outside of Sample">Chapter 30</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter31" title="Link target outside of Sample">Chapter 31</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter32" title="Link target outside of Sample">Chapter 32</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter33" title="Link target outside of Sample">Chapter 33</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter34" title="Link target outside of Sample">Chapter 34</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter35" title="Link target outside of Sample">Chapter 35</span></span></p>
<p class="toc"><span><span href="#/xhtml/chapter36" title="Link target outside of Sample">Chapter 36</span></span></p>
<p class="toc" style="margin-top:20px;"><span><span href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?dbd48a2a